import React, { useCallback } from 'react';
import { Stack, Button, Text } from '@moda/om';
import { ShippingMethod } from '../../../hooks/useCart/cart.rest';
import { FormButtonsLayout } from '../../FormButtonsLayout';
import { ShippingMethodOptionList } from '../ShippingMethodOptionList';

import './ShippingMethodForm.scss';

interface Props {
  shippingOptions: ShippingMethod[];
  // TODO: move to constants as enums
  selectedOption: number;
  onSelectOption: (selectedOption: number) => void;
  onCancel: () => void;
  onSubmit: (method: number) => void;
}

export const ShippingMethodForm: React.FC<Props> = ({
  shippingOptions,
  selectedOption,
  onSelectOption,
  onCancel,
  onSubmit
}) => {
  const handleSubmit = useCallback(() => {
    onSubmit(selectedOption);
  }, [onSubmit, selectedOption]);

  return (
    <Stack className="ShippingMethodForm" space={4}>
      <ShippingMethodOptionList
        shippingOptions={shippingOptions}
        selectedOption={selectedOption}
        onSelectOption={onSelectOption}
      />

      <Text treatment="bold1">
        Orders placed after 11AM EST will be processed the following business day.
      </Text>

      <FormButtonsLayout>
        <Button data-test-id="shipping-method--cancel" onClick={onCancel} secondary>
          Cancel
        </Button>
        <Button data-test-id="shipping-method--continue" onClick={handleSubmit} type="submit">
          Continue
        </Button>
      </FormButtonsLayout>
    </Stack>
  );
};
